import React, { memo } from 'react';

import { Checkbox } from '@components/common';

import { ITechnologyCheckbox } from '@interfaces/map/map';

import { TTechnologiesValues } from '@enums/common';

interface ITechnologyCheckboxesProps {
	checkboxClassName?: string;
	disabled?: boolean;
	groupName: string;
	onChangeTechnology: (name: TTechnologiesValues) => () => void;
	technologies: Array<ITechnologyCheckbox>;
}

const TechnologyCheckboxes = ({
	checkboxClassName,
	disabled,
	groupName,
	onChangeTechnology,
	technologies,
}: ITechnologyCheckboxesProps) => {
	return (
		<>
			{technologies.map(({
				title,
				name,
				color,
				isSelected,
			}, idx) => {
				return (
					<Checkbox
						key={`${name}-${idx}-${groupName}`}
						checked={isSelected}
						classNames={checkboxClassName}
						color={color}
						disabled={disabled}
						label={title}
						name={`${name}-${groupName}`}
						onChange={onChangeTechnology(name)}
					/>
				);
			})}
		</>
	);
};

export default memo(TechnologyCheckboxes);
